<template>
  <v-list-item class="mb-2">
    <v-list-item-content>
      <v-list-item-title>{{ field.label }}</v-list-item-title>
      <v-list-item-subtitle>
        Type: {{ field.fieldType }}
        <v-chip
          x-small
          :color="field.required ? 'error' : 'grey'"
          class="ml-2"
        >
          {{ field.required ? 'Required' : 'Optional' }}
        </v-chip>
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action class="flex-row">
      <v-btn
        icon
        small
        @click="$emit('edit')"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-btn
        icon
        small
        class="ml-1"
        title="Duplicate field"
        @click="$emit('copy')"
      >
        <v-icon>mdi-content-copy</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  name: 'FieldItem',
  props: {
    field: {
      type: Object,
      required: true
    }
  }
}
</script>
